import TopicTwo from "../../../components/platform-contents/meta-trader-web-terminal-contents/TopicTwo";

const MetaTraderWebTerminalContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__platform">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Why Traders Choose the MetaTrader Web Terminal</h1>
            <p>
              Designed for performance, speed, and simplicity. The Web Terminal
              empowers traders to act fast and stay informed.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Zero Installation Needed</h4>
                </div>
                <p>
                  Start trading instantly without any downloads, perfect for
                  traders who switch between devices or prefer browser-based
                  access.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Universal Accessibility</h4>
                </div>
                <p>
                  {" "}
                  Compatible with all major operating systems and browsers,
                  giving you uninterrupted access from any device.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Same Power, More Freedom</h4>
                </div>
                <p>
                  Enjoy the full functionality of MetaTrader - live charts,
                  analytical tools, and order management, without ever
                  installing software.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MetaTraderWebTerminalContentFive;
